import React from 'react';
import cn from 'classnames';
import moment from 'moment';

import './date-category-heading.css';

export const DateCategoryHeading = props => {
	const { categoryName, date, dateFormat, dateLink = null, ...divProps } = props;
	return (
		<div {...divProps} className={cn('date-category-heading')}>
			{categoryName && <div className={'category'}>{categoryName}</div>}
			{date && <div className={'date'}>{moment(date).format('DD MMMM, HH:mm')}</div>}
		</div>
	);
};



// WEBPACK FOOTER //
// src/components/ui/date-category-heading/date-category-heading.js